import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { defaultCompare } from "logic/DefaultCompare";
import { SelectableList, Spinner } from "components/common";
import { HelpBlock, BootstrapModalForm, Input, BootstrapModalConfirm } from "components/bootstrap";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const InputProfileAssignForm = ({
  inputProfileId,
  onClose,
  showModal = false,
  forwarders = [],
  assignedForwarders = [],
  onForwardersAssign
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedForwarders, setSelectedForwarders] = useState(null);
  const sendTelemetry = useSendTelemetry("input-profile");
  const _getFormattedForwarders = (forwardersList) => forwardersList.map((i) => ({ value: i.id, label: i.title })).sort((s1, s2) => defaultCompare(s1.label, s2.label));
  const currentAssignedForwarders = useMemo(() => _getFormattedForwarders(assignedForwarders), [assignedForwarders]);
  const effectiveAssignedForwarders = selectedForwarders || currentAssignedForwarders;
  const _openConfirmation = () => setShowConfirmModal(true);
  const _closeConfirmation = () => setShowConfirmModal(false);
  const _closeModalsAndResetState = () => {
    _closeConfirmation();
    onClose();
    if (selectedForwarders) {
      setSelectedForwarders(null);
    }
  };
  const _onSelectedForwardersChange = (selected) => {
    setSelectedForwarders(selected);
  };
  const _getFilteredForwarders = () => forwarders.filter((f) => !effectiveAssignedForwarders.some((sf) => sf.value === f.id));
  const getUnassignedForwarders = (ids) => assignedForwarders.filter((forwarder) => !ids.includes(forwarder.id)).map((forwarder) => ({ forwarderId: forwarder.id, inputProfileId: null }));
  const _saveUpdatedForwarders = () => {
    const forwardersIds = effectiveAssignedForwarders.map((sf) => sf.value);
    const assignedForwardersList = forwardersIds.map((id) => ({ forwarderId: id, inputProfileId }));
    const unassignedForwarders = getUnassignedForwarders(forwardersIds);
    onForwardersAssign([...assignedForwardersList, ...unassignedForwarders]);
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_INPUT_PROFILE_FORWARDER_ASSIGNED, {
      app_pathname: "forwarder",
      event_details: {
        unassignedForwardersCount: unassignedForwarders.length,
        assignedForwardersCount: assignedForwardersList.length
      }
    });
    _closeModalsAndResetState();
  };
  const _updateForwarder = () => {
    const forwardersIds = effectiveAssignedForwarders.map((sf) => sf.value);
    const unassignedForwarders = getUnassignedForwarders(forwardersIds);
    if (unassignedForwarders.length > 0) {
      _openConfirmation();
      return;
    }
    _saveUpdatedForwarders();
  };
  if (!forwarders) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showModal && /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: showModal,
      title: t("input_profile_assign_form.title"),
      onSubmitForm: _updateForwarder,
      onCancel: _closeModalsAndResetState,
      submitButtonText: t("input_profile_assign_form.save")
    },
    /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "input-profile-forwarder-select",
        label: t("input_profile_assign_form.forwarders_label"),
        help: /* @__PURE__ */ React.createElement(HelpBlock, null, t("input_profile_assign_form.help"))
      },
      /* @__PURE__ */ React.createElement(
        SelectableList,
        {
          options: _getFormattedForwarders(_getFilteredForwarders()),
          onChange: _onSelectedForwardersChange,
          selectedOptionsType: "object",
          selectedOptions: effectiveAssignedForwarders
        }
      )
    ))
  ), showConfirmModal && /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showConfirmModal,
      title: t("input_profile_assign_form.confirm_title"),
      onConfirm: _saveUpdatedForwarders,
      onCancel: _closeModalsAndResetState
    },
    t("input_profile_assign_form.confirm_message")
  ));
};
export default InputProfileAssignForm;
